import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { Plugin } from './plugin'

export class Selectors<TTypeParams extends ec.models.TypeParams.Constraint> {
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly isDownloading

  constructor(plugin: Plugin<TTypeParams>) {
    this.isDownloading = plugin.feature.state.project(
      state => state.isDownloading,
    )
  }
}
